/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import dayjs from 'dayjs';
import moment, { Moment } from 'moment';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { NewJobService } from 'app/components/new-job/new-job.service';
import _ from 'lodash';
import { JobReshceduleDetailsConfirmationComponent } from '../job-reshcedule-details-confirmation/job-reshcedule-details-confirmation.component';
import { TitleCasePipe } from '@angular/common';
import { calendarModule } from 'app/components/datagrid/datagrid.interface';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { TimeZoneDataType, TimezonePickerService } from 'app/core/services/timezone/timezone-picker.service';
import { MetaData } from 'ng-event-bus/lib/meta-data';
import { debounceTime, pairwise } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'edit-job-schedule.component',
  templateUrl: './edit-job-schedule.component.html',
  styleUrls: ['./edit-job-schedule.component.scss']
})
export class UpdateScheduledDateComponent implements OnInit, OnDestroy {
  updateJobScheduleForm: UntypedFormGroup;
  jobDetails: any;
  removeJob: boolean = false;
  dateChanged: boolean = false;
  disableReschedule: boolean = false;
  isScheduleAllowed: boolean = true;
  timeformat: string = 'HH:mm:ss';
  dateFormat: string = 'DD/MM/YYYY';
  routeWarning = {show: false, msg: ''};
  projectWarning = {show: false, msg: ''};
  type: any;
  dialogTitle: any;
  module: any;
  onInitialLoadStartTime: boolean = true;
  onInitialLoadEndTime: boolean = true;
  dateTimeFormat: string = this.utilityService.dateTimeFormat;
  trackEvent: any;
  showClearScheduleAlert: boolean = false;
  enableClearSchedule: boolean = false;

  timezoneSubscription: Subscription;
  defaultTimeZone: string = this.utilityService.preferredTimeZone;
  timeZoneData: Array<TimeZoneDataType> = [];
  readonly accountTimeZone: string = this.utilityService.preferredTimeZone;

  fromTimeInAccountTimeZone: Moment;
  toTimeInAccountTimeZone: Moment;

  fromTimeStepper: number = 15;
  toTimeStepper: number = 15;

  maintainIntervel: boolean = false;
  maintainIntervelType: any;
  projectUid: any;
  rescheduleBtnTitle: string = 'proceed';
  rescheduledJobsArr: any[] = [];
  currentPage: any;
  SDKSubs$: any[];
  dateValidationRanges = {
    'minStartDate': null,
    'maxStartDate': null,
    'minEndDate': null,
    'maxEndDate': null
  };
  controlNameMappingForSDK = {
    'start_date': 'from_date',
    'end_date': 'to_date'
  };
  constructor(
    public dialogRef: MatDialogRef<UpdateScheduledDateComponent>,
    private dateFormatPipe: DateFormatPipe,
    private dataCollectorService: DataCollectorService,
    private newJobService: NewJobService,
    private jobService: JobsService,
    private toast: HotToastService,
    public utilityService: UtilityService,
    private dateTimeFormatPipe: DateTimePipe,
    private localStorageService: LocalStorageService,
    private zuperDialogService: ZuperDialogService,
    private formBuilder: UntypedFormBuilder,
    private titlecasePipe: TitleCasePipe,
    private analyticsService: AnalyticsService,
    public timezoneService: TimezonePickerService,
    private _route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any){
      moment.tz.setDefault(this.defaultTimeZone);
    }


  ngOnInit(): void {
    this.jobDetails = this.data?.data;
    this.type = this.data?.type;
    this.module = this.data?.module;
    this.timeformat = this.utilityService.timeFormat;
    this.dateFormat = this.utilityService.dateFormat;
    this.trackEvent = this.data?.trackEvent;
    this.maintainIntervel = this.data.maintainIntervel || false;
    this.maintainIntervelType = this.maintainIntervel ? 'MAINTAIN' : 'NONE';
    const scheduledStartTime = this.jobDetails?.scheduled_start_time;
    this.type = this.utilityService.isEmptyOrUndefined(scheduledStartTime) ? 'SCHEDULE' : 'RESCHEDULE';
    if(this.module === 'PROJECT_GANTT_VIEW'){
      this.rescheduleBtnTitle = 'update';
    }
    this.projectUid = this.data?.projectUid;
    this.enableClearSchedule = this.data?.enableClearSchedule ?? false;
    if(this.utilityService.isTimeZoneEnabled || this.jobDetails?.job_timezone){
      this.defaultTimeZone = this.jobDetails?.job_timezone || this.jobDetails?.customer?.customer_timezone
       || this.jobDetails?.customer?.customer_organization?.organization_timezone || this.jobDetails?.organization?.organization_timezone
        || this.defaultTimeZone;
    }else{
      this.defaultTimeZone = this.utilityService.preferredTimeZone;
    }

    if(this.type==='RESCHEDULE' && this.utilityService.isEmptyOrUndefined(this.jobDetails?.job_timezone)){
      this.defaultTimeZone = this.utilityService.preferredTimeZone;
    }
    moment.tz.setDefault(this.defaultTimeZone);
    const estimatedDuration = this.jobDetails?.job_category?.estimated_duration;
    let estimateHours = estimatedDuration?.hours;
    //If estimated hours is not available, set 1 hour by default
    if (!estimatedDuration || (!estimatedDuration?.days && !estimatedDuration?.hours && !estimatedDuration?.minutes)) {
      estimateHours = 1;
    }

    let fromDate = this.jobDetails?.scheduled_start_time ? moment.tz(moment(dayjs(this.jobDetails?.scheduled_start_time).format()),this.defaultTimeZone) : this.utilityService.getNextQuarterHour(moment.tz(moment(),this.defaultTimeZone),true);
    if(this.data?.startDate && !this.utilityService.isEmptyOrUndefined(this.data?.startDate)) {
      fromDate = moment.tz(moment(this.data.startDate),this.defaultTimeZone);
    }
    let toDate = this.jobDetails?.scheduled_end_time ? moment.tz(moment(dayjs(this.jobDetails?.scheduled_end_time).format()),this.defaultTimeZone) :
    fromDate.clone()
        .add(estimatedDuration.days ?? 0, 'day')
        .add(estimateHours, 'hour')
        .add(estimatedDuration.minutes ?? 0, 'minute');
    if(this.data?.endDate && !this.utilityService.isEmptyOrUndefined(this.data?.endDate)) {
      toDate = moment.tz(moment(this.data.endDate),this.defaultTimeZone);
    }

    let toTime = this.jobDetails?.scheduled_end_time
    ? moment.tz(this.jobDetails.scheduled_end_time, this.defaultTimeZone)
    : fromDate.clone()
        .add(estimatedDuration.days ?? 0, 'day')
        .add(estimateHours, 'hour')
        .add(estimatedDuration.minutes ?? 0, 'minute');
    if(this.data?.endDate && !this.utilityService.isEmptyOrUndefined(this.data?.endDate)) {
      toTime = moment.tz(moment(this.data.endDate),this.defaultTimeZone);
    }

    this.updateJobScheduleForm = this.formBuilder.group({
      job_timezone:[this.defaultTimeZone],
      from_date: [fromDate, [Validators.required]],
      from_time_field: [fromDate.clone().format(this.timeformat)],
      from_time_picker: [fromDate],
      to_date: [toDate, [Validators.required]],
      to_time_field: [moment(toTime).clone().format(this.timeformat)],
      to_time_picker: [moment(toTime).clone()],
      reason: [''],
    });
    this.setAccountTimeZoneValue();

    this.dialogTitle = this.getDialogTitle(this.jobDetails);
    if(this.data?.reloadData){
      this.updateJobScheduleForm?.patchValue(this.data.reloadValue);
    }
    this.updateJobScheduleForm.controls.from_date.valueChanges.subscribe((response: any)=>{
      this.dateChanged = true;
      this.setCategoryDurationEndTime();
      this.checkJobWarnings();
      this.setAccountTimeZoneValue();
      this.updateTimezoneUsingDSTData();
    });

    this.updateJobScheduleForm.controls.job_timezone.valueChanges.subscribe((response: any)=>{
      this.setAccountTimeZoneValue();
      if(this.utilityService.isTimeZoneEnabled){
        moment.tz.setDefault(response);
      }
    });

    const startDate = dayjs.utc(this.jobDetails.scheduled_start_time ?? dayjs());
    let endDate = dayjs.utc(dayjs());
    if(!this.utilityService.isEmptyOrUndefined(this.jobDetails.scheduled_end_time)){
      endDate = dayjs.utc(this.jobDetails.scheduled_end_time);
    }else{
      const duration = this.jobDetails?.estimated_duration;
      if(duration?.days){
        endDate = endDate.add(duration?.days,'d');
      }
      if(duration?.hours){
        endDate = endDate.add(duration?.hours,'h');
      }
      if(duration?.minutes){
        endDate = endDate.add(duration?.minutes,'m');
      }
    }
    this.updateJobScheduleForm.controls.from_time_picker.valueChanges.subscribe((response: any)=>{
      const fromTimePicker: Moment = moment(response);
      this.fromTimeStepper = this.utilityService.getNextQuarterStepperMin(fromTimePicker);
      if (!this.onInitialLoadStartTime) {
        this.dateChanged = true;
        this.updateJobScheduleForm.controls.from_time_field.setValue(fromTimePicker.format(this.utilityService.timeFormat), { emitEvent: false });
        this.setCategoryDurationEndTime();
      }
      this.checkJobWarnings();
      this.setAccountTimeZoneValue();
      this.onInitialLoadStartTime = false;
    });

    this.updateJobScheduleForm.controls.to_time_picker.valueChanges.subscribe((response: any)=>{
      const toTimePicker: Moment = moment(response);
      this.toTimeStepper = this.utilityService.getNextQuarterStepperMin(toTimePicker);
      if (!this.onInitialLoadEndTime) {
        this.dateChanged = true;
        this.updateJobScheduleForm.controls.to_time_field.setValue(toTimePicker.format(this.utilityService.timeFormat), { emitEvent: false });
      }
      this.setAccountTimeZoneValue();
      this.checkJobWarnings();
      this.onInitialLoadEndTime = false;
    });

    this.updateJobScheduleForm.controls.to_date.valueChanges.subscribe((response: any)=>{
      this.checkJobWarnings();
      this.setAccountTimeZoneValue();
    });

    this.updateJobScheduleForm.controls.from_date.valueChanges.subscribe((response: any)=>{
      this.setAccountTimeZoneValue();
    });
    const companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
    switch (this.type) {
      case 'SCHEDULE':
        this.checkPermission(companyConfig?.jobs?.allow_fe_edit, 'job.schedule');
        break;
      case 'RESCHEDULE':
        this.checkPermission(companyConfig?.jobs?.allow_fe_reschedule, 'job.reschedule');
        break;
    }
    this.timezoneSubscription = this.timezoneService.timeZones.subscribe((timezoneRes: Array<TimeZoneDataType>)=>{
      if(timezoneRes){
        this.timeZoneData = timezoneRes;
      }
    });
    if(this.type==='RESCHEDULE' && this.utilityService.isEmptyOrUndefined(this.jobDetails?.job_timezone)){
      this.updateJobScheduleForm.controls.job_timezone.setValue(null);
    }
    this.currentPage = this.utilityService.collectRouteData(this._route.snapshot)['page'];
    this.initiateHandlersForSDK();
  }

  setCategoryDurationEndTime(): void {
    this.onInitialLoadEndTime = true;
    const updateJobScheduleFormControl: { [key: string]: AbstractControl } = this.updateJobScheduleForm.controls;
    const estimatedDuration = this.jobDetails?.job_category?.estimated_duration ?? { days: 0, hours: 0, minutes: 0 };

    const fromDateValue = updateJobScheduleFormControl.from_date.value;
    const fromTimeValue = updateJobScheduleFormControl.from_time_field.value;

    const fromDatePicker: Moment = moment(fromDateValue, 'MM/DD/YYYY');
    const fromTimeField: Moment = moment(fromTimeValue, 'hh:mm A');
    const combinedStartDateTime: Moment = moment(fromDatePicker)
      .hour(fromTimeField.hour())
      .minute(fromTimeField.minute())
      .second(0);

    const categoryDurationEndTime: Moment = combinedStartDateTime.clone()
      .add(estimatedDuration.days, 'days')
      .add(estimatedDuration.hours, 'hours')
      .add(estimatedDuration.minutes, 'minutes');

    updateJobScheduleFormControl.to_time_field.setValue(
      categoryDurationEndTime.format(this.utilityService.timeFormat), { emitEvent: false }
    );
    updateJobScheduleFormControl.to_time_picker.setValue(
      categoryDurationEndTime, { emitEvent: false }
    );
    updateJobScheduleFormControl.to_date.setValue(categoryDurationEndTime, { emitEvent: false });
  }


  updateTimezoneUsingDSTData(): void{
    const tz = this.updateJobScheduleForm.controls.job_timezone.value;
    const startDate = this.updateJobScheduleForm.controls.from_date.value ?? moment();
    this.timeZoneData = this.timezoneService.updateDisplayNamesUsingDST(this.timeZoneData,moment.tz(startDate,tz));
  }

  setAccountTimeZoneValue(): void{
    const selectedFromDate = this.updateJobScheduleForm.controls.from_date.value;
    const selectedToDate = this.updateJobScheduleForm.controls.to_date.value;
    const tz = this.updateJobScheduleForm.controls.job_timezone.value || this.accountTimeZone;

    const combinedFromDateTime = moment(selectedFromDate).tz(tz)
    .date(moment(selectedFromDate).date())
    .month(moment(selectedFromDate).month())
      .hour(moment(this.updateJobScheduleForm.value.from_time_picker, this.dateTimeFormat).hour())
      .minute(moment(this.updateJobScheduleForm.value.from_time_picker, this.dateTimeFormat).minute());

      const combinedToDateTime = moment(selectedToDate).tz(tz)
    .date(moment(selectedToDate).date())
        .month(moment(selectedToDate).month())
        .hour(moment(this.updateJobScheduleForm.value.to_time_picker, this.dateTimeFormat).hour())
        .minute(moment(this.updateJobScheduleForm.value.to_time_picker, this.dateTimeFormat).minute());

      const patchFromDate = moment.tz(combinedFromDateTime.clone(), tz);
      const patchToDate = moment.tz(combinedToDateTime.clone(), tz);

      this.fromTimeInAccountTimeZone = moment.tz(patchFromDate.clone(), this.accountTimeZone);
      this.toTimeInAccountTimeZone = moment.tz(patchToDate.clone(),this.accountTimeZone);
  }

  checkPermission(configPermission: boolean, utilityPermission: string): void {
    const currentUser = this.localStorageService.getLocalStorage('user');
    const isFieldExecutive = currentUser?.role?.role_key === 'FIELD_EXECUTIVE';
    if (isFieldExecutive) {
      if(currentUser?.access_role){
        this.isScheduleAllowed =  this.utilityService.hasPermission(utilityPermission);
      } else{
        this.isScheduleAllowed = configPermission;
      }
    } else {
      this.isScheduleAllowed = this.utilityService.hasPermission(utilityPermission);
    }
  };

  getDialogTitle(jobDetails: any): string {
    const workOrderNumber = jobDetails?.work_order_number || '';
    const prefix = jobDetails?.prefix || '';
    const jobTitle = jobDetails?.job_title || '';
    return `${this.type === 'RESCHEDULE' ? this.utilityService.getLocaleValue('text.reschedule', 'Reschedule') : this.utilityService.getLocaleValue('text.schedule', 'Schedule')}
    ${workOrderNumber !== '' ? '#' : ''}${prefix} ${workOrderNumber} ${jobTitle}`;
  }

  setDate(picker: { _selected: moment.Moment; },name: string | number): void {
    const date = this.updateJobScheduleForm?.controls[name];
    const newDate = date?.status.toLowerCase() === 'valid' ? moment(date?.value) : moment(new Date());
    picker._selected = newDate;
  }

  getMeridian(): boolean{
    return this.timeformat === 'hh:mm A' ? true : false;
  };

  showRemoveJob(): boolean{
    return !this.utilityService.isEmptyOrUndefined(this.jobDetails?.route) && !this.utilityService.isEmptyOrUndefined(this.jobDetails?.route?.route_uid) && this.dateChanged;
  }

  showDueDateError(): boolean{
    return !this.utilityService.isEmptyOrUndefined(this.jobDetails?.due_date) && dayjs(dayjs(this.jobDetails?.due_date)).isBefore(dayjs(dayjs(this.updateJobScheduleForm.value.to_date)));
  }

  getDueDateErrorMessage(): string{
    return `This Job is due by ${this.dateFormatPipe.transform(this.jobDetails?.due_date)},${dayjs(this.jobDetails?.due_date).format('dddd')}`;
  }

  isGivenDateAfterDueDate(date: string | number | Date | dayjs.Dayjs): boolean{
    return this.jobDetails?.due_date ? dayjs(this.jobDetails?.due_date).isBefore(dayjs(date)) : false;
  }

  showServiceTaskError(): boolean{
    return false;
  }

  getServiceTaskErrorMessage(): any{
    return '';
  }

  proceedIntervelMaintainance(): any{
    if(this.maintainIntervelType === 'NONE'){
      this.updateJobScheduleDate();
    } else if(this.maintainIntervelType === 'MAINTAIN'){
      let fromDate = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.from_date.value,'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.from_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
      let toDate = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.to_date.value,'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.to_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
      fromDate = dayjs(fromDate,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
      toDate = dayjs(toDate,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
      let url: string;
      let loader: CreateHotToastRef<unknown>;
      let api: Observable<any>;
      if(this.rescheduledJobsArr.length > 0 || this.module === 'PROJECT_GANTT_VIEW'){
        loader = this.toast?.loading(this.utilityService.getLocaleValue('update.job.details.loader.text'));
        url = this.jobService?.jobAPIUrls?.projectsUrl + '/' + this.projectUid + '/dependencies/reschedule?job_uid='
        + this.jobDetails.job_uid
        + '&scheduled_start_time=' + fromDate
        + '&scheduled_end_time=' + toDate
        + (this.utilityService.isTimeZoneEnabled && this.updateJobScheduleForm?.controls?.job_timezone?.value
            ? '&job_timezone=' + this.updateJobScheduleForm.controls.job_timezone.value
            : '');
         api = this.dataCollectorService.postData(url, {});
      } else{
        loader = this.toast?.loading(this.utilityService.getLocaleValue('text.project.job.reschedule.intervel.fetch.data'));
         url = this.jobService?.jobAPIUrls?.projectsUrl + '/' + this.projectUid + '/dependencies/schedule_forecast?job_uid='+ this.jobDetails.job_uid + '&scheduled_start_time=' + fromDate + '&scheduled_end_time=' + toDate;
         api = this.dataCollectorService.getData(url);
      }
      api.subscribe((resposne: any)=>{
        loader.close();
        if(this.rescheduledJobsArr.length > 0 || this.module === 'PROJECT_GANTT_VIEW'){
          this.toast.success(resposne?.message);
          this.castJobSchedule();
          this.dialogRef.close({isUpdated: true, status: 'completed'});
          this.jobService.refreshJobDetails.next({refresh: true, status: 'completed'});
        } else{
          resposne?.data?.forEach((job: { job_uid: any; rescheduledStartDate: string; reschedule_start_time: moment.MomentInput; rescheduledEndDate: string; reschedule_end_time: moment.MomentInput; scheduledStartDate: string; scheduled_start_time: moment.MomentInput; scheduledEndDate: string; scheduled_end_time: moment.MomentInput; }) => {
            if(job.job_uid !== this.jobDetails.job_uid){
              job.rescheduledStartDate = moment(job.reschedule_start_time).format(this.dateTimeFormat);
              job.rescheduledEndDate = moment(job.reschedule_end_time).format(this.dateTimeFormat);
              job.scheduledStartDate = moment(job.scheduled_start_time).format(this.dateTimeFormat);
              job.scheduledEndDate = moment(job.scheduled_end_time).format(this.dateTimeFormat);
              this.rescheduledJobsArr.push(job);
            }
            this.updateJobScheduleForm.disable({ emitEvent: false });
            this.rescheduleBtnTitle = 'update';
          });
        }
      },(error: any)=>{
        loader.close();
      });
    }
  }

  updateJobScheduleDate(): void {
    if (!this.showStartEndDateError()) {
      this.disableReschedule = true;
      if (this.updateJobScheduleForm?.valid && !this.isGivenDateAfterDueDate(this.updateJobScheduleForm.controls.from_date.value)) {
        const assignedTo = this.jobDetails.assigned_to.map((item: { user: { user_uid: any; }; }) => item.user.user_uid);
        let fromDate = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.from_date.value,'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.from_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
        let toDate = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.to_date.value,'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.to_time_field.value,this.utilityService.timeFormat).format('HH:mm:ss')}`;
        fromDate = dayjs(fromDate,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
        toDate = dayjs(toDate,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
        const payload: any = {
          'job_timezone': this.utilityService.isTimeZoneEnabled === false ? null : this.updateJobScheduleForm.controls.job_timezone.value,
          'from_date': fromDate,
          'to_date': toDate,
          'user_uid': assignedTo?.join(',') || '',
          'job_uid': this.jobDetails.job_uid,
        };
        if(assignedTo.length){
          this.dataCollectorService.putData(this.newJobService.scheduleOverlapUrl, payload).subscribe((response: any) => {
            if (response.data[0].jobs.length > 0 || response.data[0].timeoff.length > 0 || response.data[0].user_shifts.length > 0 || response.data[0].non_job_events.length > 0) {
              const warningMessage: string[] = [];
              const overlapData = response.data;
              const overlapValidation: any = {
                job: {},
                timeoff: {},
                shifts: {},
                nonJobEvnts: {}
              };
              if (overlapData?.length) {
                overlapData.forEach((data: any) => {
                  if (data?.jobs.length > 0 || data?.timeoff.length > 0 || data?.user_shifts.length > 0 || data?.non_job_events?.length > 0) {
                    //Job Overlaps Validation
                    data?.jobs?.forEach((job: any) => {
                      const assignedUser: any[] = job?.assigned_to;
                      assignedUser?.forEach((assignee: any) => {
                        const user = _.get(assignee, 'user');
                        if (user?.user_uid && assignedTo?.find((user_uid: any) => user_uid === user?.user_uid) && !overlapValidation.job[user?.user_uid]) {
                          overlapValidation.job[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
                        }
                      });
                    });
                    //Time Off Validation
                    data?.timeoff?.forEach((timeoff: any) => {
                      const user = timeoff?.['requested_by'];
                      if (user?.user_uid && assignedTo?.find((user_uid: any) => user_uid === user?.user_uid) && !overlapValidation.timeoff[user?.user_uid]) {
                        overlapValidation.timeoff[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
                      }
                    });
                    //Shift Hours Validation
                    data?.user_shifts?.forEach((shift: any) => {
                      const user = shift?.['user_details'];
                      if (user?.user_uid && assignedTo?.find((user_uid: any) => user_uid === user?.user_uid) && !overlapValidation.shifts[user?.user_uid]) {
                        overlapValidation.shifts[user?.user_uid] = user?.first_name + ' ' + (user?.last_name || '');
                      }
                    });
                    // non job events conflicts
                    data?.non_job_events?.forEach((events: any) => {
                      const userDetails = events?.['assigned_to'];
                      const assigneeDetails: any[] = userDetails?.map((assignee: any) => ({ userUid: assignee?.user?.user_uid, name: this.utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name) }));
                      assigneeDetails.forEach((user) => {
                        if (user?.userUid && assignedTo?.find((user_uid: any) => user_uid === user?.userUid) && !overlapValidation.shifts[user?.userUid]) {
                        overlapValidation.nonJobEvnts[user?.userUid] = user?.name || '';
                      }
                      });
                    });
                  }
                });
              }
              //Date & Time Warnings
              if (Object.keys(overlapValidation.timeoff)?.length) {
                const users: string[] = [];
                Object.keys(overlapValidation.timeoff).forEach((key: string) => {
                  users.push(overlapValidation.timeoff[key]);
                });
                warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.timeoff', 'Job is scheduled on a timeoff for user')} : <b>${_.uniq(users).join(', ')}</b></p>`);
              }
              //Shift Hours Warning
              if (Object.keys(overlapValidation.shifts)?.length) {
                const users: string[] = [];
                Object.keys(overlapValidation.shifts).forEach((key: string) => {
                  if(overlapValidation.shifts[key]){
                    users.push(overlapValidation.shifts[key]);
                  }
                });
                warningMessage.push(`<p>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.shift_hours_exceed', 'Job is scheduled outside the shift hours of the user')} <b>${_.uniq(users).join(', ')}</b></p>`);
              }
              //Jobs Overlap Warning
              if (Object.keys(overlapValidation.job)?.length) {
                const users: string[] = [];
                Object.keys(overlapValidation.job).forEach((key: string) => {
                  if(overlapValidation.job[key] !== 'undefined'){
                    users.push(overlapValidation.job[key]);
                  }
                });
                warningMessage.push(`<p><b>${_.uniq(users).join(', ')}</b> ${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.overlap', 'has already been assigned to another job in this time interval')}</p>`);
              }
              //Non Job Events Overlap Warning
              if (Object.keys(overlapValidation.nonJobEvnts)?.length) {
                const users: string[] = [];
                Object.keys(overlapValidation.nonJobEvnts).forEach((key: string) => {
                  if(overlapValidation.nonJobEvnts[key] !== 'undefined'){
                    users.push(overlapValidation.nonJobEvnts[key]);
                  }
                });
                warningMessage.push(`<p><b>${_.uniq(users).join(', ')}</b> ${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.non_job_event_overlap', ' has already been assigned to a non-job event during this time interval.')}</p>`);
              }
              const scheduleConfirmationDialog = this.zuperDialogService.open({
                title: `${this.utilityService.getLocaleValue('job', 'Job')} Scheduled Time Overlapping`,
                type: 'error',
                message: `<div class="space-y-2 mt-2">${warningMessage.join('')}</div>`,
                actions: {
                  confirm: {
                    show: true,
                    label: 'Continue',
                    color: 'primary',
                    confirmDisplayKey: 'continue.text'
                  },
                  cancel: {
                    show: true,
                    label: 'Cancel',
                    cancelDisplayKey: 'dataPicker.footer.cancel'
                  }
                },
                dismissible: false,
                extraClass: 'w-1/3'
              });
              scheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
                if (result) {
                  this.postUpdatedSchedule();
                }
                else {
                  this.disableReschedule = false;
                }
              });
            } else {
              this.postUpdatedSchedule();
            }
          }, (_err: any) => {
          });
        } else {
          this.postUpdatedSchedule();
        }
      } else {
        this.utilityService.sendUpdate(calendarModule.HOLD);
        this.dialogRef.close({isUpdated: false, status: 'pending'});
        const updateJobScheduleConfirmationDialog = this.zuperDialogService.open({
          title: this.utilityService.getLocaleValue('confirm.job.schedule.dialog.title'),
          type: 'error',
          message: this.utilityService.getLocaleValue('confirm.job.schedule.dialog.message'),
          actions: {
              confirm: {
                  show: true,
                  label: 'Yes,Continue',
                  color: 'primary',
                  confirmDisplayKey: 'yes.continue.text'
              },
              cancel: {
                  show: true,
                  label: 'Cancel',
                  cancelDisplayKey: 'cancel.text'
              }
          }
        });
        updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
          if (result) {
            this.postUpdatedSchedule();
          } else {
            const reloadedDialg = this.zuperDialogService.openCustom(UpdateScheduledDateComponent, {
              reloadData: true,
              reloadValue: this.updateJobScheduleForm?.value,
              data: this.jobDetails,
              extraClass: 'update-schedule-date'
            });

            reloadedDialg.afterClosed().subscribe((response) => {
              if (response) {
                  this.utilityService.sendUpdate(calendarModule.HOLD);
                  this.jobService.refreshJobDetails.next({refresh: true, status: 'pending', reschedule: true});
              }
            });
          }
        });
      }
    }
  }

  postUpdatedSchedule(): void{
      const timezone = this.updateJobScheduleForm.controls.job_timezone.value || this.accountTimeZone;
      const fromDateValue = moment(this.updateJobScheduleForm.controls.from_date.value).format('YYYY-MM-DD');
      const fromTimeValue = moment(this.updateJobScheduleForm.controls.from_time_field.value, 'hh:mm A').format('HH:mm:ss');
      const fromDateTimeString = `${fromDateValue} ${fromTimeValue}`;

      const toDateValue = moment(this.updateJobScheduleForm.controls.to_date.value).format('YYYY-MM-DD');;
      const toTimeValue = moment(this.updateJobScheduleForm.controls.to_time_field.value, 'hh:mm A').format('HH:mm:ss');
      const toDateTimeString = `${toDateValue} ${toTimeValue}`;
      const fromDate = moment.tz(fromDateTimeString, timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      const toDate = moment.tz(toDateTimeString, timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      const payload: any = {
        'from_date': fromDate,
        'to_date': toDate,
        'job_uid': this.jobDetails?.job_uid,
        'reason': this.updateJobScheduleForm?.value?.reason,
        'update_all_jobs': false,
        'remove_from_route': this.removeJob,
        'job_timezone': this.utilityService.isTimeZoneEnabled === false ? null : this.updateJobScheduleForm.controls.job_timezone.value,
      };
      const loader = this.toast?.loading(this.utilityService.getLocaleValue('update.job.details.loader.text'));
      this.dataCollectorService.putData(`${this.jobService?.jobAPIUrls?.scheduleDate}`,payload).subscribe((resposne: any)=>{
        loader.close();
        this.toast.success(resposne?.message);
        this.castJobSchedule();
        this.dialogRef.close({isUpdated: true, status: 'completed'});
        this.disableReschedule = false;
        this.utilityService.sendUpdate(calendarModule.CONFIRMED);
        this.jobService.refreshJobDetails.next({refresh: true, status: 'completed'});
        if (this.trackEvent?.trigger === 'onScheduleJobSuccess' && this.trackEvent?.eventName) {
          const eventName = this.trackEvent?.eventName.toLowerCase();
          this.analyticsService.trackEvent(eventName);
        }
      },(error: any)=>{
        loader.close();
        this.disableReschedule = false;
      });
  }

  closeJobScheduleDate(): void{
    this.utilityService.sendUpdate(calendarModule.CONTINUE);
    this.dialogRef.close({isUpdated: false, status: 'closed'});
  }

  get getRouteMessage(): string{
    const message = `${this.utilityService.getLocaleValue('remove.job.from.route')} ${this.jobDetails?.route?.route_name}`;
    return message;
  }

  showStartEndDateError(): any {
      return this.fromTimeInAccountTimeZone.isSameOrAfter(this.toTimeInAccountTimeZone);
  }

  checkJobWarnings(): void {
    const jobDetails = this.data?.data;
    this.routeWarning = { show: false, msg: '' };
    this.projectWarning = { show: false, msg: '' };
    this.disableReschedule = false;
    const fromDate: any = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.from_date.value, 'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.from_time_field.value, this.utilityService.timeFormat).format('HH:mm:ss')}`;
    const toDate: any = `${this.utilityService.convertDateWithMonthNames(this.updateJobScheduleForm.controls.to_date.value, 'YYYY-MM-DD')} ${dayjs(this.updateJobScheduleForm.controls.to_time_field.value, this.utilityService.timeFormat).format('HH:mm:ss')}`;
    const scheduledStartDate = moment.tz(moment(fromDate, 'YYYY-MM-DD HH:mm:ss'),this.defaultTimeZone);
    const scheduledEndDate = moment.tz(moment(toDate, 'YYYY-MM-DD HH:mm:ss'),this.defaultTimeZone);
    if (jobDetails && jobDetails?.route?.route_uid && !this.removeJob) {
      const routeName = jobDetails?.route?.route_name;
      const routeStartDateTime = moment(jobDetails?.route?.departure);
      const routeEndDateTime = moment(jobDetails?.route?.route_end_time);
      if(!scheduledStartDate.isBetween(routeStartDateTime, routeEndDateTime) || !scheduledEndDate.isBetween(routeStartDateTime, routeEndDateTime)) {
        this.routeWarning.show = true;
        this.routeWarning.msg = `${this.utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.route_duration_exceed', 'Job is scheduled outside the route duration')} (${this.titlecasePipe.transform(routeName)} : ${routeStartDateTime.format(this.utilityService.dateTimeFormat)} to ${routeEndDateTime.format(this.utilityService.dateTimeFormat)})`;
        this.disableReschedule = true;
      }
    }

    //Project
    const projectDetails = jobDetails?.project;
    if (jobDetails && projectDetails?.project_uid) {
      const projectName = `#${projectDetails?.project_prefix || ''}${projectDetails?.project_number || ''} ${projectDetails?.project_name || ''}`;
      if (projectDetails?.project_start_date && projectDetails?.project_end_date) {
        const projectStartDateTime = moment(projectDetails?.project_start_date).startOf('d');
        const projectEndDateTime = moment(projectDetails?.project_end_date).endOf('d');
        if (!scheduledStartDate.isBetween(projectStartDateTime, projectEndDateTime) || !scheduledEndDate.isBetween(projectStartDateTime, projectEndDateTime)) {
          this.projectWarning.show = true;
          this.projectWarning.msg = `${this.utilityService.getLocaleValue('text.project.job.duration_exceed.message', 'Job is scheduled outside the project duration')} (${projectName}: ${this.dateFormatPipe.transform(projectStartDateTime)} to ${this.dateFormatPipe.transform(projectEndDateTime)})`;
        }
      }
      else if (projectDetails?.project_due_date) {
        const projectDueDate = moment(projectDetails?.project_due_date).endOf('d');
        if(scheduledStartDate.isAfter(projectDueDate) || scheduledEndDate.isAfter(projectDueDate)) {
          this.projectWarning.show = true;
          this.projectWarning.msg = `${this.utilityService.getLocaleValue('text.project.job.due_date_exceed.message', 'Job is scheduled after the project due date')} (${projectName}: ${this.dateFormatPipe.transform(projectDueDate)}, ${projectDueDate.format('dddd')})`;
        }
      }
    }
  }

  getMessageWithNote(): string {
    const baseMessage = this.utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.message');
    if (this.jobDetails?.route) {
      return `${baseMessage} ?<br><p class="font-medium text-md mt-2 text-red-600">${this.utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.note')} ' ${this.jobDetails?.route?.route_name} '</p>`;
    }
    return `${baseMessage} ?`;
  }

  clearSchedule(): void{
    if(!this.jobDetails?.due_date) {
      this.showClearScheduleAlert = true;
      return;
    }
    const updateJobScheduleConfirmationDialog = this.zuperDialogService.open({
      title: this.utilityService.getLocaleValue('text.clear_schedule'),
      type: 'error',
      message:  this.getMessageWithNote(),
      actions: {
          confirm: {
              show: true,
              label: 'Clear Schedule',
              color: 'primary',
              confirmDisplayKey: 'text.clear_schedule'
          },
          cancel: {
              show: true,
              label: 'Cancel',
              cancelDisplayKey: 'cancel.text'
          }
      }
    });
    updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        if(this.jobDetails?.route?.route_uid) {
          const removeJobParam = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            jobs: [{ job_uid: this.jobDetails?.job_uid }], unassign_users: false
          };
          const routeUid = this.jobDetails?.route?.route_uid;

          this.dataCollectorService.deleteDataPayload(`${this.dataCollectorService.baseurl()}/routes/${routeUid}/job`, removeJobParam)
          .subscribe((response: any) => {
              this.clearScheduleJob();
          }, (error: any) => {
          });
        }
        else{
          this.clearScheduleJob();
        }
      }
    });
  }

  clearScheduleJob(): void{
    const payload: any = {
      job: {
        job_uid: this.jobDetails?.job_uid,
        due_date:  moment(this.jobDetails?.due_date)?.endOf('day')?.utc()?.format('YYYY-MM-DD HH:mm:ss'),
      }
    };
    if(this.jobDetails?.job_timezone && this.utilityService.isTimeZoneEnabled === false){
      payload.job['job_timezone'] = null;
    }
    const loader = this.toast?.loading(this.utilityService.getLocaleValue('update.job.details.loader.text'));
    this.dataCollectorService.putData(`${this.jobService?.jobAPIUrls?.jobsUrl}?clear_schedule=true`,payload).subscribe((resposne: any)=>{
      loader.close();
      this.toast.success(resposne?.message);
      this.castJobSchedule();
      this.dialogRef.close({isUpdated: true, status: 'completed'});
      this.jobService.refreshJobDetails.next({refresh: true, status: 'completed'});
    },(error: any)=>{
      loader.close();
    });
  }

  ngOnDestroy(): void {
    if(this.timezoneSubscription){
      this.timezoneSubscription.unsubscribe();
    }
  }

  castJobSchedule(): void{
    this.jobService.castJobEvent('reschedule', {
      job_uid: this.jobDetails.job_uid
    });
  }

  initiateHandlersForSDK(): void{
      this.utilityService.castModalEventToSdk('open', {
        id: 'job_reschedule',
        job_details: this.jobDetails,
      });
      const formValueChangeForSDKEmit$ = this.updateJobScheduleForm.valueChanges.pipe(debounceTime(1000), pairwise()).subscribe(([prev, next]: any[]) => {
        if (this.updateJobScheduleForm.valid) {
          this.utilityService.castModalEventToSdk('change', {
            id: 'job_reschedule',
            old_value: this.utilityService.convertMomentFieldsToDate(prev),
            new_value: this.utilityService.convertMomentFieldsToDate(next),
          });
        }
      });
      const formPatchSub$ = this.utilityService.listenForFormPatchEvent(`${this.currentPage}.job_reschedule`).pipe().subscribe((res: MetaData) => {
        const controlName = this.controlNameMappingForSDK[res.data['controlName']];
        const control = this.updateJobScheduleForm.controls[controlName];
        if(!control){
          return;
        }
        if (res.key.includes('prop')) {
          // patching configs of form control
          if (controlName && res.data['config'] && control) {
            const validations = res.data['config'];
            let pairKey = '';
            Object.keys(validations).forEach(((key: any) => {
              switch (key) {
                case 'min':
                  pairKey = controlName === 'from_date' ? 'minStartDate' : 'minEndDate';
                  this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                  if (control.value < this.dateValidationRanges[pairKey]) {
                    control.setValue(this.dateValidationRanges[pairKey]);
                  }
                  break;
                case 'max':
                  pairKey = controlName === 'from_date' ? 'maxStartDate' : 'maxEndDate';
                  this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                  if (control.value > this.dateValidationRanges[pairKey]) {
                    control.setValue(this.dateValidationRanges[pairKey]);
                  }
                  break;
                case 'disabled':
                  if((validations[key] || false)){
                    control.disable();
                  }
                  break;
              }
            }));
          };
        } else if (res.key.includes('set')) {
          //patching values of form
          if (controlName && res.data['value'] && control) {
            if (moment(control.value).isValid()) {
              control.setValue(moment(res.data['value']).isValid() ? moment(res.data['value']) : control.value);
            } else {
              control.setValue(res.data['value']);
            }
          }
        }
      });
      this.SDKSubs$ = [formValueChangeForSDKEmit$, formPatchSub$];
    }
}
